export default __webpack_public_path__ + "static/media/Farming-info-dark.2f937f22.png";